import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable()
export class AdminGaurdService {

  constructor( private  _authService: AuthService, private router : Router) { }

//Guard permettant de protéger les routes dédiées aux administrateurs
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):Observable<boolean> | Promise<boolean> | boolean{
    
    if ((this._authService.isLoggedIn() && this._authService.isAdmin()) ) {
      return true;
    } else if ( (this._authService.isLoggedIn() && this._authService.isManager())) {
      this.router.navigate(['/home'])
    } else{
      this.router.navigate(['/acceuil'])
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/gaurds/admin-gaurd.service.ts